import { Grid, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

function RepayInfo({ repayAmountMax, selectedCoin }) {
  return (
    <Grid item xs={12}>
      <SpaceBetweenBox>
        <Typography color="text.main" variant="h6">
          موجودی
        </Typography>

        <Typography color="text.main" variant="h6" textAlign="end">
          <NumberFormats value={repayAmountMax?.availableBalance || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          کارمزد وام
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={repayAmountMax?.interest || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          اصل وام
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={repayAmountMax?.borrowed || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          مجموع
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={repayAmountMax?.maximumRepaymentAmount || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>
    </Grid>
  );
}

export default RepayInfo;
